import { useState, useEffect } from 'react';

import { useGetFeromonColumns } from './useGetFeromonColumns';
import FeromonsInsectsExpandable from './FeromonsInsectsExpandable';

import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useGetFeromonTraps from 'hooks/Traps/FeromonTraps/useGetFeromonTraps';
import useScreenSize from 'hooks/Screen/useScreenSize';
import { FeromonTrap } from 'api/traps/FeromonTraps/types';
import { setAdditionalInfo } from 'pages/Traps/Slice/trapSlice';
import { useAppDispatch } from 'slices';

interface TableProps {
  slug: string;
}

const FeromonsInsectsTable: React.FC<TableProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, isLoading } = useGetFeromonTraps(slug || '', page, search, ordering);
  const { isNotLargeDesktop } = useScreenSize();

  const columns = useGetFeromonColumns(slug);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setAdditionalInfo({ totalTraps: data?.count || 0 }));
  }, [data, dispatch]);
  return (
    <div className="bg-white ">
      <FilterDataTable<FeromonTrap>
        columns={columns}
        data={data?.results || []}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotLargeDesktop}
        expandableRowsComponent={row => <FeromonsInsectsExpandable data={row.data} slug={slug} />}
      />
    </div>
  );
};

export default FeromonsInsectsTable;
